import * as Icon from "assets/icons";
import { Enums } from "utils";
import en from "assets/locales/en.json";
import { PairValue } from "types";

export const REGIONS = {
  EN: "EN",
};

export const LOCALE_STRINGS = {
  [REGIONS.EN]: en,
};

export const COUNTRY_CONSTANTS = {
  [REGIONS.EN]: {
    phoneCode: "+1",
  },
};

export const DATE_FORMAT = {
  year: "numeric",
  month: "short",
  day: "numeric",
} as any;

export const TIME_FORMAT = {
  hour: "2-digit",
  minute: "2-digit",
} as any;

export const INPUT_MASK = {
  DATE: "9999-99-99",
  PHONE: "(999) 999-9999",
  HC_ID: "9999-999-999-aa",
  POSTAL_CODE: "a9a 9a9",
};

export const INPUT_MASK_PLACEHOLDER = {
  DATE: "YYYY-MM-DD",
};

export const TEXTAREA = {
  MAX: 5,
  MIN: 3,
};

export const DEFAULT_SCHEDULE = {
  [Enums.EnumDaysOfWeek.Sunday]: { start: 0, end: 0 },
  [Enums.EnumDaysOfWeek.Monday]: { start: 9, end: 16 },
  [Enums.EnumDaysOfWeek.Tuesday]: { start: 9, end: 16 },
  [Enums.EnumDaysOfWeek.Wednesday]: { start: 9, end: 16 },
  [Enums.EnumDaysOfWeek.Thursday]: { start: 9, end: 16 },
  [Enums.EnumDaysOfWeek.Friday]: { start: 9, end: 16 },
  [Enums.EnumDaysOfWeek.Saturday]: { start: 0, end: 0 },
};

// TODO: to be removed later
// BEGIN
export const APPOINTMENT_DURATION = 10;
export const CALENDAR_ID = String(process.env.REACT_APP_CALENDAR_ID);
export const PROVIDER_ID = 5;
export const SERVICE_ID = 9;
// END

export const PAGE_LENGTH = 10;
export const MAX_INTEGER = 2147483647;
export const MIN_DATE = "1900-01-01";

const isProduction = process.env.NODE_ENV === "production";

const CLIENT_URL = isProduction ? String(process.env.REACT_APP_PRODUCTION_CLIENT_URL) : String(process.env.REACT_APP_LOCAL_CLIENT_URL);

export const API_URL = isProduction ? String(process.env.REACT_APP_PRODUCTION_API_URL) : String(process.env.REACT_APP_LOCAL_API_URL);

// TODO: I guess using number for keyCode is deprecated
export const KEYCODE = {
  ENTER: 13,
};

export const REFRESH_RATE = {
  QR_CODE: 1000,
  CHAT: 5000,
  ALERT: 15000,
  QIOSK: 30000,
};

export const QIOSK_PASSCODE = "707070";

export const RESEND_CODE_WAITING_TIME = 30;

// TODO: is it even a good idea to have the following values here or should they come from a backend request?
export const GOOGLE_API = {
  // TODO: there is no REACT_APP_GOOGLE_USERNAME in .env
  USERNAME: process.env.REACT_APP_GOOGLE_USERNAME,
  API_KEY: String(process.env.REACT_APP_GOOGLE_API_KEY),
  CLIENT_ID: String(process.env.REACT_APP_GOOGLE_CLIENT_ID),
  SECRET_KEY: String(process.env.REACT_APP_GOOGLE_CLIENT_SECRET),
  REFRESH_TOKEN: String(process.env.REACT_APP_GOOGLE_REFRESH_TOKEN),
  REDIRECT_URI: CLIENT_URL + String(process.env.REACT_APP_GOOGLE_CALLBACK_URI_ROUTE),
  AUTH: "https://accounts.google.com/o/oauth2/auth?client_id={{clientId}}&redirect_uri={{redirectUri}}&response_type=code&scope={{scope}}&access_type=offline",
  SCOPE: "https://www.googleapis.com/auth/calendar",
  AUTH_ACCESS_TOKEN: "https://oauth2.googleapis.com/token?code={{code}}&client_id={{clientId}}&client_secret={{secret}}&redirect_uri={{redirectUri}}&grant_type=authorization_code",
  AUTH_REFRESH_TOKEN: "https://oauth2.googleapis.com/token?client_id={{clientId}}&client_secret={{secret}}&refresh_token={{refreshToken}}&grant_type=refresh_token",
  CALENDAR_LIST: "https://www.googleapis.com/calendar/v3/users/me/calendarList",
  CALENDAR_INFO: "https://www.googleapis.com/calendar/v3/calendars/{{calendarId}}/acl",
  CALENDAR_INSERT: "https://www.googleapis.com/calendar/v3/calendars",
  CALENDAR_EVENT_INSERT: "https://www.googleapis.com/calendar/v3/calendars/{{calendarId}}/events",
  CALENDAR_EVENT_MANAGE: "https://www.googleapis.com/calendar/v3/calendars/{{calendarId}}/events/{{eventId}}",
  CALENDAR_FREE_BUSY: "https://www.googleapis.com/calendar/v3/freeBusy",
};

// TODO: should be a function or be accessed by a function in helpers
export const serviceMap = new Map([
  [
    Enums.EnumService.UrgentCare,
    {
      iconComponent: Icon.UrgentCare,
      enumSource: {},
      serviceName: "",
    },
  ],
  [
    Enums.EnumService.Pharmacy,
    {
      iconComponent: Icon.Pharmacy,
      enumSource: Enums.EnumPharmacy,
      serviceName: "pharmacy",
    },
  ],
  [
    Enums.EnumService.RapidReferrals,
    {
      iconComponent: Icon.RapidReferrals,
      enumSource: Enums.EnumRapidReferrals,
      serviceName: "rapid_referrals",
    },
  ],
  [
    Enums.EnumService.ChronicDiseases,
    {
      iconComponent: Icon.ChronicDiseases,
      enumSource: Enums.EnumChronicDiseases,
      serviceName: "chronic_diseases",
    },
  ],
  [
    Enums.EnumService.TravelClinic,
    {
      iconComponent: Icon.TravelClinic,
      enumSource: Enums.EnumTravelClinic,
      serviceName: "travel_clinic",
    },
  ],
  [
    Enums.EnumService.SexualHealth,
    {
      iconComponent: Icon.SexualHealth,
      enumSource: Enums.EnumSexualHealth,
      serviceName: "sexual_health",
    },
  ],
  [
    Enums.EnumService.WomensHealth,
    {
      iconComponent: Icon.WomensHealth,
      enumSource: Enums.EnumWomensHealth,
      serviceName: "women_health",
    },
  ],
  [
    Enums.EnumService.WalkInClinic,
    {
      iconComponent: Icon.WalkInClinic,
      enumSource: {},
      serviceName: "",
    },
  ],
  [
    Enums.EnumService.PhysicalHealth,
    {
      iconComponent: Icon.PhysicalHealth,
      enumSource: {},
      serviceName: "",
    },
  ],
  [
    Enums.EnumService.MentalHealth,
    {
      iconComponent: Icon.MentalHealth,
      enumSource: Enums.EnumMentalHealth,
      serviceName: "mental_health",
    },
  ],
  [
    Enums.EnumService.Health360,
    {
      iconComponent: Icon.Health360,
      enumSource: {},
      serviceName: "",
    },
  ],
]);

const pvArr = (options: string[], hasClear: boolean): PairValue[] => {
  let i = hasClear ? -1 : 0;
  hasClear && options.unshift("-");
  return options.map((option) => ({ key: i++, value: option }));
};

export const health360 = {
  livingArrangementsPV: pvArr(["Single home", "Family home", "Group home"], true),
  visionsPV: pvArr(["20/20", "20/25", "20/30", "20/40", "20/50", "20/70", "20/100"], true),
  successFailurePV: pvArr(["Success", "Failure"], true),
  scoresPV: pvArr(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"], true),
  historiesPV: pvArr(["Last 6 mo", "Last 1 yr", "Last 2 yrs", "Last 5 yrs"], true),
  sexualOrientationsPV: pvArr(["Heterosexual", "Homosexual", "Bisexual"], true),
  foodQuantitiesPV: pvArr(["Excess", "Normal", "Poor"], true),
  foodQualitiesPV: pvArr(["Balanced Diet", "Unbalanced Diet"], true),
  regularitiesPV: pvArr(["Regular", "Irregular"], true),
  activitiesPV: pvArr(["Aerobic", "Strength", "Yoga"], true),
  sleepTimingsPV: pvArr(["Consistent", "Inconsistent"], true),
  drugHistoriesPV: pvArr(["Last week", "Last month", "Last 6 months", "Last year"], true),

  orientationsPV: pvArr(["Person", "Place", "Time", "Disoriented"], false),
  speechesPV: pvArr(["Organized", "Coherent", "Rapid", "Slowed", "Mumbling"], false),
  thoughtProcessesPV: pvArr(["Organized", "Coherent", "Tangential", "Thought blocking", "Flight of ideas", "Obsessive"], false),
  perceptualProcessesPV: pvArr(["Normal", "Auditory Hallucinations", "Visual Hallucinations"], false),
  judgementIssuesPV: pvArr(["Good", "Average", "Poor"], false),
  moodDisrodersPV: pvArr(["Normal", "Hopeless", "Irritable", "Elevated", "Labile", "Depressed", "Anxious", "Sad", "Manic"], false),
  memoryDisordersPV: pvArr(["Intact", "Immediate memory problems", "Recent memory problems"], false),
  emotionalAffectPV: pvArr(["Appropriate", "Inappropriate", "Blunted", "Flat", "Tearful"], false),
  mentalDeficitsPV: pvArr(["Cognitive", "Concentration", "Attention"], false),
};

export const bigCalendar = {
  clinicItems: pvArr(["Blocked", "Clinic Hours", "Health 360 Hours", "Provider Availability"], true),
  providerItems: pvArr(["Primary Availability", "Secondary Availability"], false),
};

export const QubePlus = {
  healthGoals: pvArr(
    [
      "Weight Loss",
      "Chronic Back Pain",
      "Muscular Pain",
      "Quit Smoking",
      "Quit Alcohol Use",
      "Substance Use/Addiction",
      "Improve Mental Health",
      "Sleep Management",
      "Stress Management",
      "Cardiac Health",
    ],
    false
  ),
};
